import { type MantineColor } from '@mantine/core';
import { PaymentMethod, PublicStatus } from './model';

type Meta<Status extends string> = Record<
    Status,
    {
        color: MantineColor;
        label: string;
    }
>;

type PublicStatusMeta = Meta<PublicStatus>;

const publicStatusMeta = {
    // Neutral / Pending
    [PublicStatus.PUBLIC_STATUS_UNSPECIFIED]: {
        color: 'gray.6',
        label: 'Не определен',
    },
    [PublicStatus.PUBLIC_STATUS_CREATED]: {
        color: 'gray.6',
        label: 'Создан',
    },
    // In Progress
    [PublicStatus.PUBLIC_STATUS_PENDING]: {
        color: 'blue.5',
        label: 'В обработке',
    },
    // Success
    [PublicStatus.PUBLIC_STATUS_COMPLETED]: {
        color: 'green.6',
        label: 'Исполнен',
    },
    // Failure
    [PublicStatus.PUBLIC_STATUS_FAILED]: {
        color: 'red.6',
        label: 'Отклонен',
    },
} as const satisfies PublicStatusMeta;

export const publicStatusColors: Record<PublicStatus, MantineColor> = {
    [PublicStatus.PUBLIC_STATUS_UNSPECIFIED]: publicStatusMeta[PublicStatus.PUBLIC_STATUS_UNSPECIFIED].color,
    [PublicStatus.PUBLIC_STATUS_CREATED]: publicStatusMeta[PublicStatus.PUBLIC_STATUS_CREATED].color,
    [PublicStatus.PUBLIC_STATUS_PENDING]: publicStatusMeta[PublicStatus.PUBLIC_STATUS_PENDING].color,
    [PublicStatus.PUBLIC_STATUS_COMPLETED]: publicStatusMeta[PublicStatus.PUBLIC_STATUS_COMPLETED].color,
    [PublicStatus.PUBLIC_STATUS_FAILED]: publicStatusMeta[PublicStatus.PUBLIC_STATUS_FAILED].color,
} as const;

export const publicStatuses = [
    {
        value: PublicStatus.PUBLIC_STATUS_CREATED,
        label: publicStatusMeta[PublicStatus.PUBLIC_STATUS_CREATED].label,
    },
    {
        value: PublicStatus.PUBLIC_STATUS_PENDING,
        label: publicStatusMeta[PublicStatus.PUBLIC_STATUS_PENDING].label,
    },
    {
        value: PublicStatus.PUBLIC_STATUS_COMPLETED,
        label: publicStatusMeta[PublicStatus.PUBLIC_STATUS_COMPLETED].label,
    },
    {
        value: PublicStatus.PUBLIC_STATUS_FAILED,
        label: publicStatusMeta[PublicStatus.PUBLIC_STATUS_FAILED].label,
    },
] as const;

export const paymentMethods = [
    {
        value: PaymentMethod.METHOD_UNSPECIFIED,
        label: 'Не указан',
    },
    {
        value: PaymentMethod.METHOD_CARD,
        label: 'Карта',
    },
    {
        value: PaymentMethod.METHOD_SBP,
        label: 'СБП',
    },
];
